/* ------------------------------------------------------------------
   ml-perf.js
   Loaded once from layout/theme.liquid. Three jobs, all added after
   the 22 Sep 2026 Lighthouse run:

   1. Starts the HubSpot chat widget late. theme.liquid sets
      hsConversationsSettings.loadImmediately = false, so the tracking
      script still runs on time but the 445 KB chat bundle and its
      launcher (the page's main layout shift) wait for the visitor to
      touch the page, or for ten seconds after load.

   2. Loads the HubSpot Meetings embed only when a booking calendar is
      about to scroll into view. theme.liquid renames the embed
      script's src to data-ml-lazy-src, which makes it inert until this
      file puts the real script on the page.

   3. Names the things third party widgets leave unnamed: the Reputon
      carousel buttons and review link, the scheduler iframe, the
      "Powered by Shopify" link. Widgets render late, so this watches
      the DOM for a while rather than running once.
   ------------------------------------------------------------------ */
(function () {
  "use strict";
  if (window.__mlPerf) return;
  window.__mlPerf = true;

  /* ---------- 1. HubSpot chat, on first intent -------------------- */
  var chatStarted = false;
  var chatTimer = null;
  var intents = ["pointerdown", "keydown", "touchstart", "scroll"];

  function startChat() {
    if (chatStarted) return;
    chatStarted = true;
    clearTimeout(chatTimer);
    intents.forEach(function (e) {
      window.removeEventListener(e, startChat, { passive: true });
    });
    var go = function () {
      try {
        var w = window.HubSpotConversations && window.HubSpotConversations.widget;
        if (w && w.status && w.status().loaded) return;
        if (w) w.load();
      } catch (err) {}
    };
    if (window.HubSpotConversations && window.HubSpotConversations.widget) go();
    else (window.hsConversationsOnReady = window.hsConversationsOnReady || []).push(go);
  }

  if (!window.mlChatImmediate) {
    intents.forEach(function (e) {
      window.addEventListener(e, startChat, { passive: true });
    });
    var arm = function () { chatTimer = setTimeout(startChat, 10000); };
    if (document.readyState === "complete") arm();
    else window.addEventListener("load", arm, { once: true });
  }

  /* ---------- 2. HubSpot Meetings, near the viewport -------------- */
  function initMeetings() {
    var holder = document.querySelector("script[data-ml-lazy-src]");
    if (!holder) return;
    var src = holder.getAttribute("data-ml-lazy-src");
    var boxes = document.querySelectorAll(".meetings-iframe-container");
    var loaded = false;
    var io = null;

    function load() {
      if (loaded) return;
      loaded = true;
      if (io) io.disconnect();
      var s = document.createElement("script");
      s.src = src;
      s.async = true;
      document.body.appendChild(s);
    }

    if (!boxes.length || !("IntersectionObserver" in window)) {
      load();
      return;
    }
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { load(); return; }
      }
    }, { rootMargin: "900px 0px" });
    boxes.forEach(function (b) { io.observe(b); });
  }

  /* ---------- 3. Accessible names for third party widgets --------- */
  function label(el, text) {
    if (!el || el.getAttribute("aria-label")) return;
    if ((el.textContent || "").trim()) return;
    el.setAttribute("aria-label", text);
  }

  function patch() {
    document.querySelectorAll(".reputon-swiper-button-prev").forEach(function (b) {
      label(b, "Previous testimonial");
    });
    document.querySelectorAll(".reputon-swiper-button-next").forEach(function (b) {
      label(b, "Next testimonial");
    });
    document.querySelectorAll('a[href*="reputon.com/testimonial"]').forEach(function (a) {
      label(a, "Leave a review for Merchloop");
      a.querySelectorAll("button[data-content]").forEach(function (b) {
        label(b, b.getAttribute("data-content"));
      });
    });
    document.querySelectorAll(".powered_by_link a").forEach(function (a) {
      label(a, "Powered by Shopify");
    });
    document.querySelectorAll("iframe:not([title])").forEach(function (f) {
      var src = f.getAttribute("src") || "";
      if (/meetings(-[a-z0-9]+)?\.hubspot\.com/.test(src)) {
        f.setAttribute("title", "Book a discovery call with Merchloop");
      }
    });
    /* Footer column headings are h5 for their size. They follow the
       page's h2 and h3 section titles, so expose them as level 2. */
    document.querySelectorAll("h5.footer__heading:not([aria-level])").forEach(function (h) {
      h.setAttribute("aria-level", "2");
    });
  }

  function watch() {
    patch();
    if (!("MutationObserver" in window)) return;
    var queued = false;
    var mo = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; patch(); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); patch(); }, 30000);
  }

  function ready() {
    initMeetings();
    watch();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ready);
  else ready();
})();
